import { IValidationError } from './interfaces/ValidationError';

interface IParams {
  value: string | undefined,
  fieldName: string,
  fieldCaption: string,
}

export const validateDigitsExistence = (params: IParams): IValidationError => {
  if (/\d+/.test(params.value!)) {
    return { [params.fieldName]: `Numbers aren't allowed in ${ params.fieldCaption }` };
  }
  // @ts-ignore
  return null;
};
